  
<header class="header">
  <paf-header [intUser]="intUser"></paf-header>  
</header>
<div class="container-fluid main-container" #mainContainer>
  <router-outlet></router-outlet>
</div>
<footer class="footer d-flex align-items-center">
  <!-- <div class="color-bar">
    <img src="./assets/images/footer.jpg" />
  </div> -->
  <div class="flex-fill">
    <div *ngIf="intUser">
      <span>Utilisateur connecté : {{loggedUsername}}</span>
      <button class="btn btn-xs btn-secondary ms-1" data-toggle="tooltip" title="Nettoyer la mémoire cache" (click)="clearCache()">
        <i class="fas fa-broom"></i>
      </button> 
    </div>
  </div>
  <div *ngIf="pafVersion" class="d-flex flex-column align-items-center justify-content-center copyright mr-2">
    <div>
        Copyright © 2021 <strong class="text-primary">HEIV</strong>
    </div>
    <div class="version" >Vers. {{pafVersion.Version}} du {{pafVersion.BuildDate | date:'dd/MM/yyyy HH:mm'}}</div>
   </div>
  <!-- <router-outlet name="numTiers"></router-outlet> -->
</footer>
<div class="modal fade" id="windowlocker">
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center" style="height: 100%;width:100%;">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>